import { useState } from "react";
import { toast } from "sonner";
import { ListTree, Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { api, errMsg } from "@/lib/api";

const ROLES = [["receipts_index", "Scontrini", true], ["details_index", "Righe", true], ["reservations_index", "Premi", true]];
const fmt = (n) => n.toLocaleString("it-IT");
const split = (v) => (v || "").split(",").map((x) => x.trim()).filter(Boolean);

export function IndexPicker({ s, password, onChange }) {
  const [list, setList] = useState(null);
  const [busy, setBusy] = useState(false);

  const detect = async () => {
    setBusy(true);
    try {
      const r = await api.post("/settings/api/indices", { base_url: s.base_url, username: s.username, password: password || null, verify_ssl: !!s.verify_ssl });
      setList(r.data.indices);
      if (!r.data.indices.length) toast.info("Nessun indice trovato su questo Kibana");
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };

  const toggle = (key, name, multi) => {
    const cur = split(s[key]);
    const next = cur.includes(name) ? cur.filter((x) => x !== name) : multi ? [...cur, name] : [name];
    onChange(key, next.join(","));
  };

  return (
    <div className="sm:col-span-2 space-y-3">
      <Button type="button" variant="outline" size="sm" data-testid="api-detect-indices-button" onClick={detect} disabled={busy}>
        <ListTree className="mr-2 h-4 w-4" />{busy ? "Lettura indici..." : "Rileva indici da Kibana"}
      </Button>
      {list && (
        <div className="overflow-hidden rounded-lg border border-slate-200" data-testid="api-indices-list">
          <table className="w-full text-xs">
            <thead className="bg-slate-50 text-left text-slate-500"><tr><th className="px-3 py-2 font-medium">Indice</th><th className="px-3 py-2 font-medium text-right">Documenti</th><th className="px-3 py-2 font-medium">Usa come</th></tr></thead>
            <tbody>
              {list.map((i) => (
                <tr key={i.name} className="border-t border-slate-100" data-testid={`api-index-row-${i.name}`}>
                  <td className="px-3 py-2 font-mono">{i.name}{i.role && <span className="ml-2 rounded bg-slate-100 px-1.5 py-0.5 font-sans text-[10px] text-slate-500">{ROLES.find(([k]) => k === i.role)?.[1]}?</span>}</td>
                  <td className="px-3 py-2 text-right tabular-nums text-slate-600">{fmt(i.documents)}</td>
                  <td className="px-3 py-2">
                    <div className="flex gap-1">
                      {ROLES.map(([k, l, multi]) => {
                        const on = split(s[k]).includes(i.name);
                        return <button type="button" key={k} data-testid={`api-index-${i.name}-${k}`} onClick={() => toggle(k, i.name, multi)}
                          className={`rounded-full border px-2 py-0.5 transition-colors ${on ? "border-blue-600 bg-blue-600 text-white" : "border-slate-200 text-slate-600 hover:border-blue-400"}`}>
                          {on && <Check className="mr-1 inline h-3 w-3" />}{l}</button>;
                      })}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <p className="border-t border-slate-100 bg-slate-50 px-3 py-2 text-[11px] text-slate-500">Scontrini, Righe e Premi accettano più indici (es. un indice per anno); Premi è facoltativo. In alternativa puoi scrivere un pattern con asterisco (es. <span className="font-mono">ete_*_reservations</span>) per includere automaticamente gli anni futuri. Dopo la scelta premi "Salva e usa API esterne".</p>
        </div>
      )}
    </div>
  );
}
